import { render, staticRenderFns } from "./Gracias.vue?vue&type=template&id=14f61335&scoped=true&"
import script from "./Gracias.vue?vue&type=script&lang=js&"
export * from "./Gracias.vue?vue&type=script&lang=js&"
import style0 from "./Gracias.vue?vue&type=style&index=0&id=14f61335&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f61335",
  null
  
)

export default component.exports